import type { SVGProps } from 'react';
const SvgSnippetFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#snippet_folder_svg__a)">
      <path
        fill="currentColor"
        d="m15.88 10.5 1.62 1.62v3.38h-3v-5h1.38ZM22 8v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h6l2 2h8c1.1 0 2 .9 2 2Zm-3 3.5L16.5 9H13v8h6v-5.5Z"
      />
    </g>
    <defs>
      <clipPath id="snippet_folder_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSnippetFolder;
